import { render, staticRenderFns } from "./Silhouette.vue?vue&type=template&id=247932bb&lang=html&"
import script from "./Silhouette.vue?vue&type=script&lang=js&"
export * from "./Silhouette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports